import { ProjectDto } from '@/core';
import { useMemo } from 'react';
import { sort } from '@/utils';
import { getColumnSettings } from '@/pages/Projects.Constructor';

export const useColumnsOptions = (projectData: ProjectDto) => {
  const userColumns = useMemo(
    () =>
      projectData.columns
        .filter((column) => !getColumnSettings(column.type).isDefault)
        .map((column) => ({ label: column.name, value: column.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData],
  );

  const defaultColumns = useMemo(
    () =>
      projectData.columns
        .filter((column) => getColumnSettings(column.type).isDefault)
        .map((column) => ({ label: getColumnSettings(column.type).label, value: column.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData],
  );

  return useMemo(
    () => [
      { label: 'Default Columns', options: defaultColumns },
      { label: 'User Columns', options: userColumns },
    ],
    [defaultColumns, userColumns],
  );
};
